module.exports = __webpack_public_path__ + "static/img/hero-dogecoin.e1536dfc.png";